/* eslint-disable quotes */

/**
 * Define como a linguagem é exibida no editor.
 */
export const languageDef = {
  wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\#\$\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
  defaultToken: '',
  brackets: [
    { open: '{', close: '}', token: 'delimiter.curly' },
    { open: '[', close: ']', token: 'delimiter.square' },
    { open: '(', close: ')', token: 'delimiter.parenthesis' },
  ],
  parenFollows: ['se', 'enquanto', 'parametro'],
  number: /\d+(\.\d+)?/,
  globalEntity: /\@[a-zA-Z0-9_.]+(\[[a-zA-Z0-9]+\])?[.]?[a-zA-Z0-9]+/,
  keywords: [
    'var',
    'enquanto',
    'senao',
    'se',
    'parar',
    'parametro',
    'caso',
    'padrao',
    'retorno',
    'verdadeiro',
    'falso',
  ],
  typeKeywords: ['nulo'],
  operators: ['<', '>', '<=', '>=', '==', '!=', '+', '-', '*', '/', '&&', '||', '!', '=', '+=', '-=', '*=', '/='],
  symbols: /[=><!~?:&|+\-*\/\^%]+/,
  function: /_[A-Za-z0-9_]+(?=\((.*?)\))/,
  tokenizer: {
    root: [
      [
        /[a-z$][\w$]*/,
        {
          cases: {
            '@typeKeywords': 'keyword',
            '@keywords': 'keyword',
            '@default': 'identifier',
          },
        },
      ],
      { include: '@comment' },
      [
        /@symbols/,
        {
          cases: {
            '@operators': 'delimiter',
            '@default': '',
          },
        },
      ],
      //{ include: '@comment' },
      { include: '@whitespace' },
      { include: '@numbers' },
      { include: '@functions' },
      { include: '@globalEntities' },
      [/[;,.]/, 'delimiter'],
      [/[{}()\[\]]/, '@brackets'],
      [/"/, { token: 'string.quote', next: '@string' }],
    ],
    globalEntities: [[/@globalEntity/, 'support.constant']],
    whitespace: [[/[\n\t\r\n]+/, 'white']],
    numbers: [[/@number/, 'number']],
    functions: [[/@function/, 'support.function']],
    comment: [[/[\/][\/](.*)/, 'comment']],
    string: [
      [/[^\\"]+/, 'string'],
      [/\\./, 'string.escape.invalid'],
      [/"/, { token: 'string.quote', next: '@pop' }],
    ],
  },
};

/**
 * Configura o comportamento do Editor.
 */
export const configuration = {
  comments: {
    lineComment: '//',
  },
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"', notIn: ['string', 'comment'] },
  ],
  surroundingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
};

/**
 * Função de correção rápida para erro de falta de retorno.
 * @param {object} error Dados sobre o erro
 * @param {*} uri Uri de controle do Monaco Editor
 */
export const returnFix = (error, uri) => {
  return {
    title: `Adicionar retorno`,
    diagnostics: [error],
    kind: 'quickfix',
    edit: {
      edits: [
        {
          resource: uri,
          edit: { text: '\nretorno;', range: error },
        },
      ],
    },
    isPreferred: true,
  };
};

/**
 * Função de correção rápida de erros relacionados a caractere faltando.
 * @param {object} error Dados sobre o erro
 * @param {*} uri Uri de controle do Monaco Editor
 */
export const missingFix = (error, uri) => {
  return {
    title: `Adicionar '${error.source}'`,
    diagnostics: [error],
    kind: 'quickfix',
    edit: {
      edits: [
        {
          resource: uri,
          edit: {
            text: error.source,
            range: new monaco.Range(error.startLineNumber, error.startColumn, error.startLineNumber, error.startColumn),
          },
        },
      ],
    },
    isPreferred: true,
  };
};
